import { RouteContext } from '@common/contexts';
import classnames from 'classnames';
import { observer } from 'mobx-react';
import React, { useContext } from 'react';
import { Nav } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import useBreadcrumbs from 'use-react-router-breadcrumbs';
export interface BreadCrumbProps {
  positionSticky?: boolean;
}
export const BreadCrumbTrail = observer(
  ({ positionSticky }: BreadCrumbProps) => {
    const routes = useContext(RouteContext.get());
    const breadcrumbs = useBreadcrumbs(routes).filter(
      (bc) => bc.match.pathname !== '/',
    );
    const lastKey =
      breadcrumbs.length > 0 ? breadcrumbs.slice(-1)[0].key : undefined;
    return (
      <Nav
        className={classnames('h5 px-3 pt-3 pb-0', {
          'sticky-top smoke adjust-top-for-nav': positionSticky,
        })}
        aria-label="breadcrumb"
      >
        <ol className="breadcrumb mb-0">
          {breadcrumbs.map(({ key, match, breadcrumb }) => (
            <li
              key={key}
              className={classnames(
                'breadcrumb-item',
                key === lastKey ? 'active' : '',
              )}
            >
              <h5 className="visually-hidden">{breadcrumb}</h5>
              <NavLink to={match.pathname}>
                <span>{breadcrumb}</span>
              </NavLink>
            </li>
          ))}
        </ol>
      </Nav>
    );
  },
);
